import { defineMessages } from 'react-intl';

export default defineMessages({
    type: {
        id: 'ml.quoteandbind.pupanimalliability.type',
        defaultMessage: 'Type'
    },
    breed: {
        id: 'ml.quoteandbind.pupanimalliability.breed',
        defaultMessage: 'Breed'
    },
    animalName: {
        id: 'ml.quoteandbind.pupanimalliability.animalName',
        defaultMessage: 'Animal Name'
    },
    birthYear: {
        id: 'ml.quoteandbind.pupanimalliability.birthYear',
        defaultMessage: 'Birth Year'
    },
    distinctiveMarks: {
        id: 'ml.quoteandbind.pupanimalliability.distinctiveMarks',
        defaultMessage: 'Distinctive Markings or Tattoo(s)'
    },
    animalDwelling: {
        id: 'ml.quoteandbind.pupanimalliability.animalDwelling',
        defaultMessage: 'Animal Dwelling'
    },
    hasBitten: {
        id: 'ml.quoteandbind.pupanimalliability.hasBitten',
        defaultMessage: 'Has Bitten'
    }
});
